import React, { FunctionComponent } from "react";
import { PaymentPatreonPage } from "./component";

export const PaymentPatreonPageContainer: FunctionComponent = () => {
  return <PaymentPatreonPage />;
};
